export default __webpack_public_path__ + "static/media/cheffy_tools.3c62d246.jpg";